import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion, useInView } from 'framer-motion';
import { Sparkles, ArrowRight, MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const CTASection = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' });

  return (
    <section ref={sectionRef} className="py-20 md:py-28 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-fabric" />
      <div className="absolute inset-0 bg-fabric-texture" />
      
      {/* Decorative Elements */}
      <div className="absolute top-10 left-10 w-32 h-32 border border-silver/10 rounded-full" />
      <div className="absolute bottom-10 right-10 w-48 h-48 border border-silver/5 rounded-full" />
      <div className="absolute top-1/2 left-1/4 w-2 h-2 bg-pearl rounded-full animate-float" />
      <div className="absolute top-1/3 right-1/3 w-3 h-3 bg-pearl-pink rounded-full animate-float delay-300" />

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="max-w-2xl mx-auto text-center"
        >
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-silver/20 bg-card/30 backdrop-blur-sm mb-6">
            <Sparkles className="h-4 w-4 text-silver" />
            <span className="text-sm text-silver font-sans">Limited Slots Available</span>
          </div>

          {/* Headline */}
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-foreground leading-tight mb-6">
            Ready to Create Your
            <span className="text-gradient-silver block mt-2">Nikah Masterpiece?</span>
          </h2>

          {/* Description */}
          <p className="text-lg text-muted-foreground font-body mb-10 max-w-lg mx-auto">
            Let us turn your vision into a timeless treasure. 
            Every piece is handcrafted with duas, love, and barakah.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/customize">
              <Button variant="ivory" size="xl" className="w-full sm:w-auto group">
                <Sparkles className="h-5 w-5" />
                Start Customizing
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Button>
            </Link>
            <a
              href="https://wa.me/919111841033?text=Assalamu%20Alaikum!%20I%20have%20a%20custom%20order%20inquiry."
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button variant="whatsapp" size="xl" className="w-full sm:w-auto">
                <MessageCircle className="h-5 w-5" />
                Chat on WhatsApp
              </Button>
            </a>
          </div>

          {/* Trust Note */}
          <p className="text-sm text-muted-foreground mt-8 font-body italic">
            “Made with love, care, and barakah.”
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
